import React from 'react';
import moment from 'moment';
import { SelectField } from 'react-md';
import PropTypes from 'prop-types';
import { TIME_FORMAT } from '../constants';


const TimePicker = (
	{
		beginLimit = "12:00 am",
		endLimit,
		step,
		defaultValue,
		onChange,
		value,
		label,
		placeholder,
		availableSlots,
		startTime,
		disable=false,
		acceptableBookingTime = true
	}) => {
		
	// Determine step interval based on acceptableBookingTime if step is not provided
	const timeInterval = step !== undefined ? step : (acceptableBookingTime ? 30 : 60);

	const isEarlierThanEndLimit = (timeValue, endLimit, lastValue) => {
		let timeValueIsEarlier = moment(timeValue, TIME_FORMAT).diff(moment(endLimit, TIME_FORMAT)) < 0
		let timeValueIsLaterThanLastValue = lastValue === undefined ? true : moment(lastValue, TIME_FORMAT).diff(moment(timeValue, TIME_FORMAT)) < 0
		return timeValueIsEarlier && timeValueIsLaterThanLastValue;
	}

	let options = [];
	let timeValue = beginLimit;
	let lastValue;

	options.push({title:timeValue, value:timeValue});
	

    while (isEarlierThanEndLimit(timeValue, endLimit, lastValue) ) {
		lastValue = timeValue;
      	timeValue = moment(timeValue, TIME_FORMAT).add(timeInterval, 'minutes').format(TIME_FORMAT);
	  	options.push({title:timeValue, value:timeValue});
		
	}

	if(availableSlots && availableSlots.length > 0){
		const filteredSlots = [];
		const minBookingMinutes = acceptableBookingTime ? 30 : 60;
		let validTime = false;
		if(label === 'Start Time'){
			availableSlots.forEach(slot => {
				const latestAllowedStart = moment(slot.endTime, TIME_FORMAT).subtract(minBookingMinutes, 'minutes');
				options.forEach(opt => {
					if (
						moment(opt.value, TIME_FORMAT).isSameOrAfter(moment(slot.startTime, TIME_FORMAT)) &&
						moment(opt.value, TIME_FORMAT).isSameOrBefore(latestAllowedStart)
					) {
						filteredSlots.push(opt);
					}
				});
			});
		} else{
			availableSlots.forEach(slot => {
				if (
					startTime &&
					moment(startTime, TIME_FORMAT).isSameOrAfter(moment(slot.startTime, TIME_FORMAT)) &&
				moment(startTime, TIME_FORMAT).isSameOrBefore(moment(slot.endTime, TIME_FORMAT))
				) {
					const earliestAllowedEnd = moment(startTime, TIME_FORMAT).add(minBookingMinutes, 'minutes');
					options.forEach(opt => {
						if (
							moment(opt.value, TIME_FORMAT).isSameOrAfter(earliestAllowedEnd) &&
							moment(opt.value, TIME_FORMAT).isSameOrBefore(moment(slot.endTime, TIME_FORMAT))
						) {
							filteredSlots.push(opt);
						}
					});
				}
			});
		}
		options = filteredSlots;
		
	}

	// if (value && !options.some(o => o.value === value)) {
	// 	options.unshift({ title: value, value });
	// }
	

    return (
		<SelectField
			placeholder={placeholder}
			label={label}
			simplifiedMenu={true}
			value={value}
			onChange={value=>onChange(value)}
			menuItems={options}
			defaultSelected={value}
			disabled={disable}
		/>
	);

};
TimePicker.propTypes = {
	beginLimit : PropTypes.string,
	endLimit: PropTypes.string,
	step : PropTypes.number,
	defaultSelected : PropTypes.string,
	onChange : PropTypes.func,
	value: PropTypes.string,
	label: PropTypes.string,
	placeholder : PropTypes.string
  };
export default TimePicker;
